import React, {useState, useEffect, Fragment} from "react";
import { Link, useNavigate } from 'react-router-dom'
import { facultyPosURL } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { FallingLines } from 'react-loader-spinner'

const DashboardFaculty = () => {


    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        ApproveListing();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [resultFaculty, setResultFaculty] = useState([]);   
	const [facultyLength, setFacultyLength] = useState('');
    const [loader, setLoader] = useState(true);      

    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: facultyPosURL,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResultFaculty(response.data.data);
			setFacultyLength(response.data.data.length);
            setLoader(false)

          }).catch((error) =>{
            
            localStorage.removeItem('token')
    
            navigate("/")

            console.log('error',error.message)
            
          });

    }


    let sl=1;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard - Admin/Staff  </h2>
                        </div>
                    </div>

                    {!loader?
                        <div class="container">
                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col">School Name</th>
                                    <th scope="col">Faculty Name</th>
                                    <th scope="col">Positions</th>
                                    <th scope="col" style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                {
												resultFaculty?.map((item,index) =>(
												<Fragment>

												<tr key={index}>
                                                    <td>{sl++}</td>
													<td>{decode(item.schoolname)}</td>
													<td>{item.facultyName}</td>
													<td style={{textAlign:'justify'}}>{item.positions}</td>
                                                    <td>
                                                        <div className="list-action-wrpr showicons roundicons-text">
                                                            <div className="list-action-wrpr">
                                                            <Link  to={"/school_list/faculty/"+item.schoolid} data-toggle="tooltip" title="View">
                                                                <i class="view icon-eye"></i>
                                                                <span>View</span>
                                                            </Link>
                                                            </div>
                                                        </div>
                                                    </td>
												</tr>
												</Fragment>
												))
											}
         
                                </tbody>
                            </table>
                        </div>:

                        <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                        <div className="fp-container">
                            <FallingLines
                                color="#fff"
                                width="50"
                                visible={true}
                                ariaLabel='falling-lines-loading'
                                />
                        </div>
                        </div>

                        }

                    </div>
                </div>
            </aside>
        </div>
    )
};

export default DashboardFaculty;
